import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/VirtualizedTree/VirtualizedTree.tsx",
    _templateObject,
    _templateObject2,
    _templateObject3,
    _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React, { useCallback, useMemo, useState } from 'react';
import { AutoSizer, List } from 'react-virtualized';
import { equals } from 'ramda';
import styled from 'styled-components';
import { isNotEmpty, useDebounce } from '@gmini/utils';
import { usePending } from '@gmini/utils/lib/usePending';
import { getFlatTreeParentItems } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function isCreateNode(item) {
  return _typeof(item.ref) && item.ref.type === 'CreateNode';
}

export function VirtualizedTree(_ref) {
  var _table$columns;

  var flatTree = _ref.flatTree,
      _rowHeight = _ref.rowHeight,
      itemRenderer = _ref.itemRenderer,
      breadcrumbsRenderer = _ref.breadcrumbsRenderer,
      onHighlightItem = _ref.onHighlightItem,
      table = _ref.table,
      heightSubtitle = _ref.heightSubtitle,
      inCreateNode = _ref.inCreateNode;
  var ref = React.useRef(null);
  var tableRef = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      breadCrumbData = _React$useState2[0],
      setBreadCrumbData = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      scrollProps = _React$useState4[0],
      setScrollProps = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      scrolled = _React$useState6[0],
      setScrolled = _React$useState6[1];

  var _usePending = usePending({
    delayTime: 700
  }),
      pending = _usePending.pending,
      setPending = _usePending.setPending;

  var topOffset = useMemo(function () {
    return flatTree.reduce(function (acc, flatNode, index) {
      var prevRowHeight = acc[acc.length - 1] || 0;
      var rowHeightResult = typeof _rowHeight === 'function' ? _rowHeight(flatNode) : _rowHeight;
      acc.push(prevRowHeight + (index === 0 ? 0 : rowHeightResult));
      return acc;
    }, []);
  }, [flatTree, _rowHeight]);
  var rowHeightAverage = useMemo(function () {
    return flatTree.length > 0 ? flatTree.reduce(function (acc, flatNode) {
      var rowHeightResult = typeof _rowHeight === 'function' ? _rowHeight(flatNode) : _rowHeight;
      return acc + rowHeightResult;
    }, 0) / flatTree.length : 0;
  }, [flatTree, _rowHeight]);
  var rowRender = useCallback( // eslint-disable-next-line react/no-unused-prop-types
  function (_ref2) {
    var idx = _ref2.index;
    var item = flatTree[idx];

    if (!item) {
      throw new Error('[VirtualizedTree]: Not found item');
    }

    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        top: "".concat(topOffset[idx], "px"),
        left: 0,
        minWidth: '100%',
        zIndex: 10000,
        display: 'flex'
      },
      children: /*#__PURE__*/_jsx("div", {
        style: {
          flexGrow: 1
        },
        children: itemRenderer({
          item: item
        })
      })
    }, idx);
  }, [flatTree, itemRenderer, topOffset]);
  var setBreadCrumbs = React.useCallback(function (flatNodeData) {
    setBreadCrumbData(function (old) {
      return equals(old, flatNodeData) ? old : flatNodeData;
    });
  }, []);
  var onScroll = React.useCallback(function (params) {
    var _flatTree$index;

    if (tableRef.current) {
      tableRef.current.scrollTop = params.scrollTop;
    }

    setScrollProps(params);

    if (!params.scrollTop || pending) {
      setBreadCrumbs([]);
      return;
    }

    setScrollProps(null);
    var startIndex = Math.floor(params.scrollTop / rowHeightAverage);
    var partiallyOutside = params.scrollTop % rowHeightAverage;
    var index = partiallyOutside !== 0 ? startIndex + 1 : startIndex;

    if (!((_flatTree$index = flatTree[index]) !== null && _flatTree$index !== void 0 && _flatTree$index.path)) {
      return;
    }

    var flatItems = getFlatTreeParentItems(flatTree[index].path, flatTree).filter(isNotEmpty);

    if (flatItems.length >= 1 && partiallyOutside > rowHeightAverage / 3 || partiallyOutside < 1) {
      var _flatItems = getFlatTreeParentItems(flatTree[index + 1].path, flatTree).filter(isNotEmpty);

      setBreadCrumbs(_flatItems);
      return;
    }

    if (partiallyOutside >= 1) {
      setBreadCrumbs(flatItems);
    }
  }, [flatTree, pending, rowHeightAverage, setBreadCrumbs]);
  React.useEffect(function () {
    if (!pending && scrollProps) {
      onScroll(scrollProps);
    }
  }, [onScroll, pending, scrollProps]);
  var onScrollTo = React.useCallback(function (index) {
    var el = ref.current;

    if (el) {
      el.scrollToRow(index);
      setBreadCrumbData([]);
      setPending(true);

      if (onHighlightItem) {
        var item = flatTree[index];
        onHighlightItem(item);
      }
    }
  }, [flatTree, onHighlightItem, ref, setPending]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isScrolling = _useState2[0],
      setIsScrolling = _useState2[1];

  var isScrollingHandle = useDebounce({
    handler: useCallback(function () {
      return setIsScrolling(false);
    }, []),
    delay: 500
  });

  var onScrollTable = function onScrollTable() {
    setIsScrolling(true);
    isScrollingHandle();

    if (tableRef.current) {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollToPosition(tableRef.current.scrollTop);
    }
  };

  React.useEffect(function () {
    if (!pending && inCreateNode && flatTree.length > 0 && ref.current && !scrolled) {
      var index = flatTree.findIndex(isCreateNode);

      if (index === -1) {
        return;
      }

      ref.current.scrollToRow(index);
      setScrolled(true);
    }
  }, [inCreateNode, flatTree, pending, scrolled]);
  React.useEffect(function () {
    setScrolled(false);
  }, [inCreateNode]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [table && /*#__PURE__*/_jsx(TreeHead, {
      height: heightSubtitle,
      children: "\u042D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        height: table ? "calc(100% - ".concat(heightSubtitle, ")") : '100%',
        position: 'relative',
        zIndex: 100000,
        paddingTop: '6px'
      },
      children: [breadcrumbsRenderer && breadCrumbData && breadcrumbsRenderer({
        breadCrumbData: breadCrumbData,
        scrollTo: onScrollTo
      }), /*#__PURE__*/_jsx(AutoSizer, {
        children: function children(_ref3) {
          var height = _ref3.height,
              width = _ref3.width;
          return /*#__PURE__*/_jsx(List, {
            ref: ref,
            rowHeight: function rowHeight(params) {
              return typeof _rowHeight === 'function' ? _rowHeight(flatTree[params.index]) : _rowHeight;
            },
            height: height,
            width: width // eslint-disable-next-line react/forbid-component-props
            ,
            style: {
              overflowY: 'auto',
              overflowX: 'auto' // Отключено т.к. синхронный скрол с таблицей работает некорректно
              // scrollBehavior: 'smooth',

            },
            rowCount: flatTree.length,
            rowRenderer: rowRender,
            onScroll: onScroll
          });
        }
      }), table === null || table === void 0 ? void 0 : table.renderTableWrap({
        content: /*#__PURE__*/_jsx("div", {
          style: {
            position: 'absolute',
            height: 'calc(100% - 30px)',
            width: '100%',
            overflow: 'auto'
          },
          ref: tableRef,
          onScroll: onScrollTable,
          children: /*#__PURE__*/_jsxs("table", {
            style: {
              boxSizing: 'border-box',
              borderCollapse: 'collapse',
              minWidth: '100%'
            },
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsx(TableRow, {
                children: (_table$columns = table.columns) === null || _table$columns === void 0 ? void 0 : _table$columns.map(function (_ref4, idx) {
                  var name = _ref4.name;
                  return (
                    /*#__PURE__*/
                    // eslint-disable-next-line react/no-array-index-key
                    _jsx(TableHeadCell, {
                      children: name
                    }, idx)
                  );
                })
              })
            }), /*#__PURE__*/_jsx("tbody", {
              style: {
                pointerEvents: isScrolling ? 'none' : undefined
              },
              children: flatTree.map(function (item) {
                return /*#__PURE__*/_jsx(React.Fragment, {
                  children: table === null || table === void 0 ? void 0 : table.renderTableRow({
                    item: item
                  })
                }, item.path.join('_'));
              })
            })]
          })
        })
      })]
    })]
  });
}
export var TableCell = styled.td(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 6px 15px;\n  box-sizing: border-box;\n\n  font-weight: 500;\n  font-size: 14px;\n\n  color: #000335;\n\n  &:not(:last-child) {\n    border-right: 1px solid #e2e4e9;\n  }\n  line-height: 1;\n"])));
var TableHeadCell = styled.th(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 100000;\n  padding: 6px 15px;\n\n  box-sizing: border-box;\n  background: #fafafa;\n  box-shadow: 0px 4px 7px -2px rgba(34, 60, 80, 0.2);\n\n  text-align: left;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 1;\n\n  color: #a2a3b7;\n\n  &:not(:last-child) {\n    border-right: 1px solid #e2e4e9;\n  }\n"])));
export var TableRow = styled.tr(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 30px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #f4f4fa;\n  }\n\n  ", "\n"])), function (p) {
  return p.hover ? "background-color: #f4f4fa;" : '';
});
var TreeHead = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 38px;\n  ", ";\n  padding: 11px 15px;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 1;\n  box-shadow: 0px 4px 7px -2px rgba(34, 60, 80, 0.2);\n\n  /* Light gray */\n\n  color: #a2a3b7;\n"])), function (props) {
  return props.height && "height: ".concat(props.height, ";");
});